<template>
  <div class="why">
    <img class="why__bg" src="@images/whyBg1.svg" alt="bg">
    <div class="why__item">
      <div class="container">
        <div class="why__item-wrapper">
          <div class="why__block">
            <div>
              <p>{{ t('home.why.text1-1') }}</p>
              <p>{{ t('home.why.text1-2') }}</p>
            </div>
          </div>
          <h2 class="why__item-title">{{ t('home.why.title') }}</h2>
        </div>
      </div>
    </div>
    <div class="why__item2">
      <img class="why__item2-bg" src="@images/whyBg2.svg" alt="bg">
      <div class="container">
        <div class="why__item2-wrapper">
          <h2 class="why__item2-title">{{ t('home.why.title2') }}</h2>
          <img src="@images/whyImage1.png" alt="image">
        </div>
      </div>
    </div>
    <div class="why__item3">
      <div class="container">
        <div class="why__item3-wrapper">
          <div class="why__item3-block">
            <div>
              <p>{{ t('home.why.text3') }}</p>
              <img src="@images/whyImage2.png" alt="image">
            </div>
          </div>
          <h2 class="why__item2-title">{{ t('home.why.title3') }}</h2>
        </div>
      </div>
    </div>
    <div class="why__item4">
      <div class="container why__contact">
        <div class="why__item4-wrapper">
          <div class="why__contact-title" id="whyContact">
            <p>{{ t('home.why.contact') }}</p>
          </div>
          <div class="why__contact-inner">
            <contact-form />
            <img src="@images/whyContact.png" alt="image">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import ContactForm from "@/components/forms/contact-form.vue";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.why {
  position: relative;

  &__bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  &__item {
    position: relative;

    &-wrapper {
      position: relative;
      z-index: 1;
      padding-block: 150px 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 75px;
    }

    &-title {
      white-space: nowrap;
      color: $white;
      text-align: center;
      text-shadow: 0 4px 8.2px rgba(0, 0, 0, 0.25);
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: #229EB6;
      font-family: Syne, sans-serif;
      font-size: 50px;
    }
  }

  &__block {
    background-color: #6ACBDE;
    border-radius: 15px;
    padding: 0 0 28px 28px;

    & div {
      border-radius: 15px;
      background-color: $white;
      padding: 30px 40px;
      display: flex;
      flex-direction: column;
      gap: 15px;

      color: #696969;
      font-family: "Hanken Grotesk", sans-serif;
      font-size: 22px;
      font-weight: 500;
    }
  }

  &__item2 {
    position: relative;
    z-index: 1;

    &-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }

    &-wrapper {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 60px;
      padding-block: 115px;

      & img {
        width: 750px;
      }
    }

    &-title {
      color: $white;
      text-align: left;
      text-shadow: 0 4px 8.2px rgba(0, 0, 0, 0.25);
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: #229EB6;
      font-family: Syne, sans-serif;
      font-size: 50px;
    }
  }

  &__item3 {
    position: relative;
    z-index: 1;
    padding-block: 100px;

    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 90px;
    }

    &-block {
      width: fit-content;
      background-color: #6ACBDE;
      border-radius: 15px;
      padding: 0 0 28px 28px;

      & div {
        position: relative;
        border-radius: 15px;
        background-color: $white;
        display: flex;
        flex-direction: column;
        gap: 15px;
        padding-left: 130px;

        & p {
          top: 30px;
          left: 0;
          position: absolute;
          width: 240px;
          padding: 5px 5px 5px 10px;
          border-radius: 0 40px 40px 0;
          background-color: #2b3044;
          box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
          text-transform: uppercase;
          color: $white;
          font-family: Syne, sans-serif;
          font-size: 20px;
          font-weight: 900;
        }

        & img {
          width: 525px;
          border-radius: 0 15px 15px 0;
        }
      }
    }
  }

  &__item4 {
    margin-top: 150px;
    position: relative;
    z-index: 1;
  }

  &__contact {
    width: 100%;
    flex-direction: column;
    align-items: flex-start !important;

    &-title {
      position: relative;
      z-index: 1;
      width: fit-content;
      background-color: $white;
      border-radius: 16px 70px 0 0;
      padding: 18px 60px 18px 38px;

      & p {
        font-family: Syne, sans-serif;
        font-size: 50px;
        font-weight: 700;
        background: linear-gradient(90deg, #FF85FD 0.5%, #7D045A 44.83%, #3D2B44 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    &-inner {
      width: 100%;
      margin-bottom: 25px;
      background-color: $white;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 55px 35px;
      border-radius: 0 8px 8px 8px;
      box-shadow: 0 4px 9.6px 0 rgba(0, 0, 0, 0.25);
    }
  }
}

@media (max-width: 1600px) {
  .why {
    &__item {
      &-wrapper {
        padding-block: 100px 50px;
      }
    }

    &__item3 {
      padding-block: 80px;
    }
  }
}

@media (max-width: 1450px) {
  .why {
    &__item3 {
      padding-block: 0;

      &-block {
        padding: 0 0 15px 15px;
      }
    }

    &__block {
      padding: 0 0 15px 15px;

      & div {
        padding: 20px 30px;
        font-size: 18px;
      }
    }
  }
}

@media (max-width: 1300px) {
  .why {
    &__item {
      &-title {
        font-size: 38px;
      }
    }

    &__item2 {
      &-wrapper {
        & img {
          width: 500px;
        }
      }

      &-title {
        font-size: 38px;
      }
    }

    &__contact {
      width: 90%;

      &-inner {
        gap: 25px;

        & img {
          width: 500px;
          height: 366px;
          object-fit: cover;
          border-radius: 10px;
        }
      }
    }
  }
}

@media (max-width: 1100px) {
  .why {
    &__item {
      &-wrapper {
        padding-block: 100px 10px;
      }
    }

    &__item2 {
      &-wrapper {
        padding-block: 115px 75px;
      }
    }

    &__block {
      & div {
        font-size: 14px;
      }
    }

    &__item3 {
      &-block {
        & div {
          & p {
            width: 165px;
            font-size: 14px;
          }

          & img {
            width: 300px;
          }
        }
      }
    }

    &__contact {
      &-inner {
        flex-direction: column;

        & img {
          display: none;
        }
      }
    }
  }
}

@media (max-width: 950px) {
  .why {
    &__item {
      &-title {
        font-size: 30px;
      }
    }

    &__item2 {
      &-wrapper {
        padding-block: 75px;

        & img {
          width: 400px;
        }
      }

      &-title {
        font-size: 30px;
      }
    }
  }
}

@media (max-width: 850px) {
  .why {
    &__item {
      &-wrapper {
        padding-block: 50px 10px;
      }
    }

    &__item2 {
      &-wrapper {
        & img {
          width: 300px;
        }
      }
    }

    &__item3 {
      &-block {
        & div {
          padding-left: 55px;

          & p {
            width: 120px;
            font-size: 10px;
          }

          & img {
            width: 250px;
          }
        }
      }
    }

    &__block {
      & div {
        padding: 10px 20px;
        font-size: 10px;
      }
    }

    &__contact {
      &-title {
        & p {
          font-size: 30px;
        }
      }
    }
  }
}

@media (max-width: 700px) {
  .why {
    &__item {
      &-title {
        font-size: 24px;
      }

      &-wrapper {
        gap: 25px;
      }
    }

    &__item2 {
      &-title {
        font-size: 24px;
      }

      &-wrapper {
        padding-block: 50px;
      }
    }

    &__item3 {
      &-wrapper {
        gap: 25px;
      }
    }
  }
}

@media (max-width: 600px) {
  .why {
    &__item {
      &-title {
        font-size: 20px;
      }
    }

    &__block {
      border-radius: 10px;
      padding: 0 0 10px 10px;

      & div {
        border-radius: 10px;
        padding: 5px 10px;
        font-size: 8px;
      }
    }

    &__item2 {
      &-title {
        font-size: 20px;
      }

      &-wrapper {
        & img {
          width: 250px;
        }
      }
    }

    &__item3 {
      &-block {
        border-radius: 10px;
        padding: 0 0 10px 10px;

        & div {
          & img {
            border-radius: 0 10px 10px 0;
            width: 200px;
          }

          & p {
            top: 10px;
            width: 100px;
            font-size: 8px;
          }
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .why {
    &__bg {
      height: 450px;
      object-fit: cover;
    }

    &__item {
      &-wrapper {
        padding-block: 30px 10px;
      }

      &-title {
        font-size: 16px;
      }
    }

    &__item2 {
      &-wrapper {
        padding-block: 40px;
        gap: 20px;

        & img {
          width: 200px;
        }
      }

      &-title {
        font-size: 16px;
      }
    }

    &__item3 {
      &-block {
        & div {
          padding-top: 20px;
          padding-left: 30px;

          & img {
            width: 150px;
          }
        }
      }
    }

    &__contact {
      &-title {
        padding-left: 15px;
      }

      & p {
        font-size: 22px;
      }
    }
  }
}
</style>